module.exports = __webpack_public_path__ + "img/spike-protein-variant5.7f688dbb.png";